import React, { FC, useEffect, useState } from 'react';
import { METRICS } from '@types';
import { appStore } from '@store';
import { useT } from 'hooks';
import checkTheme from 'utils/custom/checkTheme';

import * as S from './styled';
import chart3 from './img/chart3.svg';
import chart1 from './img/chart1.svg';
import chart3Dark from './img/chart3Dark.svg';
import chart1Dark from './img/chart1Dark.svg';

export const Chart: FC = () => {
	const { surveyStore, unitsStore } = appStore;
	const units = unitsStore.isMetrics ? METRICS.KG : METRICS.LBS;
	const { answers } = surveyStore;
	const { T } = useT();
	const [curentWeight, setCurentWeight] = useState<number>(0);
	const [goalWeight, setGoalWeight] = useState<number>(0);
	const [chart, setChart] = useState(false);
	const [firstMonth, setFirstMonth] = useState<string | null>(null);
	const [secondMonth, setSecondMonth] = useState<string | null>(null);
	const [thirdMonth, setThirdMonth] = useState<string | null>(null);
	const [fourthMonth, setFourthMonth] = useState<string | null>(null);
	const [interimWeight, setInterimWeight] = useState<number>(0);
	const selectedChart1 = checkTheme() === 'darkMode' ? chart1Dark : chart1;
	const selectedChart3 = checkTheme() === 'darkMode' ? chart3Dark : chart3;

	useEffect(() => {
		if (answers.weight?.[0]) {
			setCurentWeight(JSON.parse(answers.weight?.[0]).value);
		}
		if (answers.target_weight?.[0]) {
			setGoalWeight(JSON.parse(answers.target_weight?.[0]).value);
		}
		getMonths();
	}, []);

	useEffect(() => {
		if (goalWeight && curentWeight && goalWeight === curentWeight) {
			setChart(true);
		}
		if (goalWeight && curentWeight) {
			setInterimWeight(curentWeight - Math.round((curentWeight - goalWeight) / 2));
		}
	}, [curentWeight, goalWeight]);

	function getMonths() {
		const currentDate = new Date();
		const indexMonth = currentDate.getMonth();
		const ArrMonth = [
			T('i18n_monthNames_1'),
			T('i18n_monthNames_2'),
			T('i18n_monthNames_3'),
			T('i18n_monthNames_4'),
			T('i18n_monthNames_5'),
			T('i18n_monthNames_6'),
			T('i18n_monthNames_7'),
			T('i18n_monthNames_8'),
			T('i18n_monthNames_9'),
			T('i18n_monthNames_10'),
			T('i18n_monthNames_11'),
			T('i18n_monthNames_12'),
			T('i18n_monthNames_1'),
			T('i18n_monthNames_2'),
			T('i18n_monthNames_3'),
			T('i18n_monthNames_4'),
			T('i18n_monthNames_5'),
			T('i18n_monthNames_6'),
			T('i18n_monthNames_7'),
			T('i18n_monthNames_8'),
			T('i18n_monthNames_9'),
			T('i18n_monthNames_10'),
			T('i18n_monthNames_11'),
			T('i18n_monthNames_12'),
		];
		setFirstMonth(ArrMonth[indexMonth]);
		setSecondMonth(ArrMonth[indexMonth + 1]);
		setThirdMonth(ArrMonth[indexMonth + 2]);
		setFourthMonth(ArrMonth[indexMonth + 3]);
	}

	return (
		<S.Container>
			<S.Description1 chart={chart}>
				{chart ? <p>{T('info_graphic_label2')}</p> : <p>{T('info_graphic_label4')}</p>}
			</S.Description1>
			<S.ChartWrapper chart={chart}>
				{chart ? (
					<>
						<S.Label chart={chart}>
							{curentWeight} {units}
						</S.Label>
						<S.Label chart={chart}>
							{curentWeight} {units}
						</S.Label>
						<S.Label chart={chart}>
							{curentWeight} {units}
						</S.Label>
						<S.Label chart={chart}>
							{curentWeight} {units}
						</S.Label>
					</>
				) : (
					<>
						<S.Label>
							{curentWeight} {units}
						</S.Label>
						<S.Label>
							{interimWeight} {units}
						</S.Label>
						<S.Label>
							{goalWeight} {units}
						</S.Label>
						<S.Label>
							{goalWeight} {units}
						</S.Label>
					</>
				)}
				<S.Chart chart={chart}>
					{chart ? (
						<img src={selectedChart3} alt='chart' />
					) : (
						<img src={selectedChart1} alt='chart' />
					)}
				</S.Chart>
			</S.ChartWrapper>
			<S.ChartMonts>
				<p>{firstMonth}</p>
				<p>{secondMonth}</p>
				<p>{thirdMonth}</p>
				<p>{fourthMonth}</p>
			</S.ChartMonts>
			<S.Description2 chart={chart}>
				{chart ? <p>{T('info_graphic_label3')}</p> : <p>{T('info_graphic_label1')}</p>}
			</S.Description2>
		</S.Container>
	);
};
